import {
    getLeads,
    createLead,
    convertLead as convertLeadApi,
    editLead,
    viewLeads,
    addNotes,
    sendEmail,
    deleteLead,
} from "@/services/channel";

const state = {
    leadsData: [] as any[],
    leadCreationStatus: null as number | null,
    leadConversionStatus: null as number | null,
    viewLeadData: null as any,
    addNotesStatus: null as number | null,
    sendEmailStatus: null as number | null,
    deleteLeadStatus: null as number | null,
};

const mutations = {
    SET_LEADS_DATA(state: any, data: any[]) {
        state.leadsData = data;
    },
    SET_LEAD_CREATION_STATUS(state: any, status: number) {
        state.leadCreationStatus = status;
    },
    SET_LEAD_CONVERSION_STATUS(state: any, status: number) {
        state.leadConversionStatus = status;
    },
    SET_VIEW_LEAD_DATA(state: any, data: any) {
        state.viewLeadData = data;
    },
    SET_ADD_NOTES_STATUS(state: any, status: number) {
        state.addNotesStatus = status;
    },
    SET_SEND_EMAIL_STATUS(state: any, status: number) {
        state.sendEmailStatus = status;
    },
    SET_DELETE_LEAD_STATUS(state: any, status: number) {
        state.deleteLeadStatus = status;
    },
};

const actions = {
    async fetchLeads({ commit }: any, payload: any) {
        try {
            const response = await getLeads(payload);
            commit("SET_LEADS_DATA", response);
            return response;
        } catch (error) {
            console.error("fetchLeads failed", error);
            throw error;
        }
    },

    async addLead({ commit }: any, payload: any) {
        try {
            const response = await createLead(payload);
            commit("SET_LEAD_CREATION_STATUS", response.status);
            return response;
        } catch (error) {
            console.error("addLead failed", error);
            throw error;
        }
    },

    async convertLeadAction({ commit }: any, payload: any) {
        try {
            const response = await convertLeadApi(payload);
            commit("SET_LEAD_CONVERSION_STATUS", response.status);
            return response;
        } catch (error) {
            console.error("convertLead failed", error);
            throw error;
        }
    },

    async editLead(_context: any, payload: any) {
        try {
            const response = await editLead(payload);
            return response;
        } catch (error) {
            console.error("editLead failed", error);
            throw error;
        }
    },

    async viewLead({ commit }: any, id: string) {
        try {
            const response = await viewLeads(id);
            commit("SET_VIEW_LEAD_DATA", response);
            return response;
        } catch (error) {
            console.error("viewLead failed", error);
            throw error;
        }
    },

    async addNotesAction({ commit }: any, payload: any) {
        try {
            const response = await addNotes(payload);
            commit("SET_ADD_NOTES_STATUS", response.status);
            return response;
        } catch (error) {
            console.error("addNotes failed", error);
            throw error;
        }
    },

    async sendEmailAction({ commit }: any, payload: any) {
        try {
            const response = await sendEmail(payload);
            commit("SET_SEND_EMAIL_STATUS", response.status);
            return response;
        } catch (error) {
            console.error("sendEmail failed", error);
            throw error;
        }
    },

    async deleteLeadAction({ commit }: any, payload: { id: string; tenant: string }) {
        const response = await deleteLead(payload);
        commit("SET_DELETE_LEAD_STATUS", response.status);
        return response;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
